import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SocialMediaLinks from '../SocialMediaLinks';

import style from './Bio.module.scss';

const Bio = ({ name = '', description = '', links = [], theme = {} }) => {
  if (!name) return null;
  return (
    <section className={classNames(style.container, theme.bioContainer)}>
      <div className={classNames(style.innerContainer, theme.innerContainer)}>
        <h3 className={classNames(style.title, theme.title)}>
          <div>About</div> <div>{name}</div>
        </h3>
        <p className={classNames(style.description, theme.description)}>{description}</p>
        <SocialMediaLinks links={links} theme={{ container: style.linksContainer }} />
      </div>
    </section>
  );
};

export default Bio;

Bio.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      alt: PropTypes.string,
      link: PropTypes.string,
      logo: PropTypes.element,
      text: PropTypes.string,
    }),
  ),
  theme: PropTypes.shape({}),
};
